import React, { useState, useEffect, useRef } from 'react'
import {  Button, Grid, Typography, Tooltip, Card } from '@mui/material';
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import format from "dayjs/plugin/utc";
import editIcon from "../../assets/icons/edit-icon.svg";
import CommonModal from '../modal/CommonModal';
import { makeStyles } from '@mui/styles';
import InputFieldComponent from '../common/InputFieldComponent';
import DateTimePickerComponent from '../common/DateTimePickerComponent';
import { serviceProvider } from '../../provider/serviceProvider';
import { toast } from 'react-toastify';
import ButtonComponent from '../common/ButtonComponent';
import Loader from '../loader/Loader';
import addImageIcon from "../../assets/icons/add-image.svg";
import S3 from "react-aws-s3-typescript";
import { awsConfig } from "../../configuration/config.json";
import { ValidationUtiltiy } from '../../utility/ValidationUtility';
import { IValidationResponse } from '../../interface/IValidation';
import { ValidationType } from '../../enum/validationType';
dayjs.extend(utc);
dayjs.extend(format);



const initalUserInput = {
    active: true,
    datetimeToDeactivate:"",
    feedDescription: "",
    feedId: 0,
    feedTitle: "",
    redirect_link: {
      cta_link:"",
      cta_name:"Know More",
    },
    imageUrl: {
  mobile: "",
  desktop: "",
},

}

const EditFeed = ({ feedDetails,getAllFeeds }:any) => {
  const [open, setOpen] = useState<boolean>(false);
  const [loader, setLoader] = useState(false);
  const [userInput, setUserInput] = useState(initalUserInput)
  const [deactivateDateTime, setDeactivateDateTime] = useState<any>(null);
  const [imgLoader,setImgLoader]=useState(false)
  const [file, setFile] = useState<any>(null);
  const [activeImage, setActiveImage] = useState<"mobile" | "desktop" | null>(null);

  const chooseFileRef: React.MutableRefObject<HTMLInputElement | null> = useRef(null);

const handleChooseFile = (type: "mobile" | "desktop") => {
  setActiveImage(type);
  chooseFileRef.current?.click();
};



  const handleOpenModal = () => setOpen(true);
  const handleCloseModal = () => setOpen(false);

const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { name, value } = event.target;

  if (name === "cta_link" || name === "cta_name") {
    setUserInput((prev) => ({
      ...prev,
      redirect_link: {
        ...prev.redirect_link,
        [name]: value,
      },
    }));
  } else {
    setUserInput((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  validateFieldsOnInput(name);
};

const validateFieldsOnInput = (key: string) => {
  switch (key) {
    case "feedTitle":
      validateFeedTitle();
      break;

    case "cta_link":
      validateRedirectLink();
      break;

    case "cta_name":
      validateCTAName();
      break;

    default:
      break;
  }
};



  const handleDeactivateDateTime = (newDate: any) => {
    setDeactivateDateTime(newDate);
}

const handleFileChange = (event: any) => {
  const fileObj = event.target.files && event.target.files[0];
  if (!fileObj) return;

  const isValid = ValidationUtiltiy.isValidImg(fileObj.name);
  if (!isValid) {
    toast.error("Not a valid image file");
    return;
  }

  const newFileName = "123_" + fileObj.name.replace(/\..+$/, "");
  uploadImage(fileObj, newFileName);
};


const uploadImage = (file: any, newFile: any) => {
  setImgLoader(true);
  const ReactS3Client = new S3(awsConfig);

  ReactS3Client.uploadFile(file, awsConfig.feedsSubFolder + "/" + newFile)
    .then((data) => {
      if (data.status === 204) {
        updateUserInput(data.location, activeImage);
        toast.success(`${activeImage?.toUpperCase()} image uploaded successfully`);
      } else {
        toast.error("Error uploading image");
      }
      setImgLoader(false);
    })
    .catch(() => {
      toast.error("Something went wrong while uploading");
      setImgLoader(false);
    });
};


const updateUserInput = (imageUrl: string, type: "mobile" | "desktop" | null) => {
  if (!type) return;
  setUserInput((prev) => ({
    ...prev,
    imageUrl: {
      ...prev.imageUrl,
      [type]: imageUrl,
    },
  }));
};


  const handleEditFeed = (feedId:any) => {
    const formattedDeactivateDateTime = deactivateDateTime
  ? dayjs(deactivateDateTime).utc().format("YYYY-MM-DDTHH:mm:ss")
  : "";

  const searchParams = new URLSearchParams(window.location.search);
  const index = searchParams.get("index");

  // 🔹 Determine active value based on index
  const isActive = index === "0";

    const payload = {
  ...userInput,
  datetimeToDeactivate: formattedDeactivateDateTime,
  imageUrl: JSON.stringify(userInput.imageUrl), 
  active: isActive,
  redirect_link: JSON.stringify(userInput.redirect_link), 
};

    isValidRequest().then(() => {
    setLoader(true);
    serviceProvider.feedService.put(feedId, payload).then((res:any) => {
      if (res.responseCode === 200) {
        toast.success(res.message)
        handleCloseModal();
        window.location.reload();
        // const query = `search?feedTitle=all&feedId=all&isActive=true&offset=0&limit=10&order=updatedTs.desc&profile=BASIC`
        // getAllFeeds(query)
      }else{
        toast.error(res?.message||"Something Went Wrong.")
      }
      setLoader(false)
      console.log({ res })
    }).catch((err) => {
        toast.error(err?.data?.message||"Something Went Wrong.")
      console.log({ err })
      setLoader(false)
    })
  }).catch(() => {
    toast.error('Please fill all the Required Fields!');
})
  }
  



useEffect(() => {
  if (!feedDetails) return;

  setDeactivateDateTime(dayjs(feedDetails?.datetimeToDeactivate));

  // Handle both old string URLs and new JSON format
  let parsedImages = { mobile: "", desktop: "" };
  try {
    parsedImages = feedDetails?.imageUrl
      ? JSON.parse(feedDetails.imageUrl)
      : { mobile: feedDetails.imageUrl || "", desktop: "" };
  } catch {
    parsedImages = { mobile: feedDetails.imageUrl || "", desktop: "" };
  }
  let parsedCTADetail = { cta_link: "", cta_name: "" };
  try {
    parsedCTADetail = feedDetails?.redirect_link
      ? JSON.parse(feedDetails.redirect_link)
      : { cta_link: "", cta_name: "" };
  } catch {
    parsedCTADetail = { cta_link: "", cta_name: "" };
  }

  setUserInput({
    ...feedDetails,
    imageUrl: parsedImages,
    redirect_link: parsedCTADetail,
  });
}, [feedDetails]);



//   const handleEditAirport=()=>{

//   }

  const modalBody = (
    <Grid container spacing={4}>
    <Grid item xs={12} className="modal-table-container">
        <Grid container className='heading'>
            <Grid item xs={12}>
                <Typography variant='h6' component='h6'>Edit Feed</Typography>
            </Grid>
        </Grid>
        <Grid container className="edit-detail-item">
            <Grid item xs={6} className='edit-item dark-bg'>
                <Typography variant='body1' component='p'>
                    Title
                </Typography>
            </Grid>
            <Grid item xs={6} className='edit-item'>
                <Grid item xs={12} >
                    <InputFieldComponent
                        id="feed-title"
                        type="text"
                        name="feedTitle"
                        value={userInput.feedTitle}
                        onChange={handleInputChange}
                    />
                    <span className="modalError" id='errorDiv-feed-title'></span>
                </Grid>


            </Grid>
        </Grid>
        
        <Grid container className="edit-detail-item">
            <Grid item xs={6} className='edit-item dark-bg'>
                <Typography variant='body1' component='p'>
                    Redirect Url
                </Typography>
            </Grid>
            <Grid item xs={6} className='edit-item'>
                <Grid item xs={12} >
                    <InputFieldComponent
                        id="cta-link"
      type="url"
      name="cta_link"
      value={userInput.redirect_link.cta_link}
      onChange={handleInputChange}
                    />
                    <span className="modalError" id="errorDiv-cta-link"></span>
                </Grid>

            </Grid>
        </Grid>
       <Grid container className="edit-detail-item">
                    <Grid item xs={6} className='edit-item dark-bg'>
                        <Typography variant='body1' component='p'>
                           CTA Label
                        </Typography>
                    </Grid>
                    <Grid item xs={6} className='edit-item'>
                        <Grid item xs={12} >
                            <InputFieldComponent
                                id="cta-name"
      type="text"
      name="cta_name"
      value={userInput.redirect_link.cta_name}
      onChange={handleInputChange}
                            />
                            <span className="modalError" id="errorDiv-cta-name"></span>
                        </Grid>

                    </Grid>
                </Grid>
        <Grid container className="edit-detail-item">
            <Grid item xs={6} className='edit-item dark-bg'>
                <Typography variant='body1' component='p'>
                    Deactivate Date Time
                </Typography>
            </Grid>
            <Grid item xs={6} className='edit-item'>
                <DateTimePickerComponent
                    placeholder="Deactivate Date Time"
                    value={deactivateDateTime}
                    disablePast={true}
                    onChange={handleDeactivateDateTime}
                />

            </Grid>
        </Grid>
       

    </Grid>
<Grid item xs={12} container spacing={2}>
  {/* 📱 Mobile Banner Image Upload */}
  <Grid item xs={12} md={6}>
    <Typography
      variant="subtitle1"
      sx={{ fontWeight: 600, mb: 1, textAlign: { xs: "center", md: "left" } }}
    >
      Mobile Banner Image
    </Typography>

    {imgLoader && activeImage === "mobile" ? (
      <Loader height="230px" width="100%" />
    ) : (
      <Card className="feed-image-card">
        <img
          src={userInput.imageUrl.mobile || addImageIcon}
          className={`${userInput.imageUrl.mobile ? "card-img" : "add-img"}`}
          alt="mobile"
          onClick={() => handleChooseFile("mobile")}
        />
      </Card>
    )}
  </Grid>

  {/* 💻 Desktop Banner Image Upload */}
  <Grid item xs={12} md={6}>
    <Typography
      variant="subtitle1"
      sx={{ fontWeight: 600, mb: 1, textAlign: { xs: "center", md: "left" } }}
    >
      Desktop Banner Image
    </Typography>

    {imgLoader && activeImage === "desktop" ? (
      <Loader height="230px" width="100%" />
    ) : (
      <Card className="feed-image-card">
        <img
          src={userInput.imageUrl.desktop || addImageIcon}
          className={`${userInput.imageUrl.desktop ? "card-img" : "add-img"}`}
          alt="desktop"
          onClick={() => handleChooseFile("desktop")}
        />
      </Card>
    )}
  </Grid>

  {/* Hidden File Input */}
  <input
    style={{ display: "none" }}
    ref={chooseFileRef}
    type="file"
    onChange={handleFileChange}
  />
</Grid>


    <Grid item xs={12} >
        <Grid container columnSpacing={2} display="flex" justifyContent="center" alignItems="center" mt="20px">
            <Grid item xs={2}>
                <ButtonComponent loader={loader} disabled={loader} label="Save" onClick={()=>handleEditFeed(feedDetails?.feedId)} />
            </Grid>
        </Grid>
    </Grid>
</Grid>
  )
  return (
    <>
      <CommonModal open={open} handleCloseModal={handleCloseModal} modalBody={modalBody} />
     <Tooltip title="Edit">
     <Button onClick={handleOpenModal}>
        <img src={editIcon} alt="edit icon" height="20px" width="20px" />
      </Button>
     </Tooltip>
    </>
  )
}

export default EditFeed;




const isValidRequest = (): Promise<boolean> => {
  const responseArray: IValidationResponse[] = [];
  responseArray.push(validateFeedTitle());
  responseArray.push(validateRedirectLink());
  responseArray.push(validateCTAName());

  const haveErrors = responseArray.filter((x) => !x.isValid).length <= 0;
  return new Promise((resolve, reject) => {
    haveErrors ? resolve(true) : reject(false);
  });
};

const validateFeedTitle = () => {
    return ValidationUtiltiy.validateElement("feed-title", ValidationType.Text, true, "errorDiv-feed-title", "Title");
}
const validateRedirectLink = () => {
  return ValidationUtiltiy.validateElement(
    "cta-link",
    ValidationType.URL,
    true,
    "errorDiv-cta-link",
    "Redirect URL"
  );
};

const validateCTAName = () => {
  return ValidationUtiltiy.validateElement(
    "cta-name",
    ValidationType.Text,
    true,
    "errorDiv-cta-name",
    "CTA Label"
  );
};



